import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 缓存类型
    CACHE_TYPE_: computed(() => (
      store.state.label.data.CACHE_MANAGE?.CACHE_TYPE_
    )),
    // 缓存大类
    DATA_TYPE_ONE_ARR: computed(() => (
      store.state.label.data.CACHE_MANAGE?.DATA_TYPE_ONE_ARR
    )),
    // 缓存元素类型
    DATA_TYPE_TWO_ARR: computed(() => (
      store.state.label.data.CACHE_MANAGE?.DATA_TYPE_TWO_ARR
    )),
    // 平台分类
    PLATFORM_CLASS: computed(() => (
      store.state.label.data.CACHE_MANAGE?.PLATFORM_CLASS
    ))
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    showName,
    ...computedData
  }
}
